import { FieldValues } from "react-hook-form";
import { TestStateItem } from "./types";

const validateRequiredField = (value: any, fieldName: string): string | undefined => {
  return value === undefined || value === null ? `${fieldName} is required` : undefined;
};

const validateTestDates = (test: TestStateItem): Record<string, string> => {
  const errors: Record<string, string> = {};
  const { start_datetime, end_datetime } = test;

  if (start_datetime === undefined || start_datetime === null || end_datetime === undefined || end_datetime === null) {
    errors.start_datetime = "Start datetime is required";
    errors.end_datetime = "End datetime is required";
  } else if (start_datetime >= end_datetime) {
    errors.start_datetime = "Start datetime must be before end datetime";
    errors.end_datetime = "End datetime must be after start datetime";
  }

  return errors;
};

export const validateForm = (values: FieldValues) => {
  const errors: Record<string, any> = {};

  const typeError = validateRequiredField(values.type, "Type");
  const siteError = validateRequiredField(values.site_id, "Site");
  const lowDroopError = validateRequiredField(values.lowDroop, "Low Droop");
  const highDroopError = validateRequiredField(values.highDroop, "High Droop");

  if (typeError) errors.type = typeError;
  if (siteError) errors.site_id = siteError;
  if (lowDroopError) errors.lowDroop = lowDroopError;
  if (highDroopError) errors.highDroop = highDroopError;

  if (values.tests_config) {
    const allTestsUnselected = values.tests_config.every((test: TestStateItem) => !test.selected);

    if (allTestsUnselected) {
      const testErrors: Record<string, any> = {};
      values.tests_config.forEach((test: TestStateItem, index: number) => {
        testErrors[index] = { selected: "At least one test is required" };
      });
      errors.tests_config = testErrors;
    } else {
      values.tests_config.forEach((test: TestStateItem, index: number) => {
        if (test.selected) {
          const dateErrors = validateTestDates(test);
          if (Object.keys(dateErrors).length > 0) {
            if (!errors.tests_config) errors.tests_config = {};
            errors.tests_config[index] = dateErrors;
          }
        }
      });
    }
  }

  return errors;
};
